import { deepCopy } from '@portals/shared/common/utils';
import { TrackRoute } from '@portals/shared-frontend/components';

import { useBackend } from '@/hooks/useBackend';
import PageTimelineContent from '@/pages/explorer/apis/page/regulatory-apis/PageTimelineContent';

import ApiPage from '../../components/ApiPage';
import { API_EXPLORER_TABS } from '../../content';

export default function RegulatoryApis() {
  const { data: apis, mutate } = useBackend('/apis/regulatory');

  return (
    <ApiPage
      apiType={API_EXPLORER_TABS.Regulatory}
      apis={apis}
      onApiFavouriteChange={(apiId, isFavorite) =>
        mutate((apis) => {
          if (apis) {
            const updatedApis = deepCopy(apis);
            const index = updatedApis.findIndex((api) => api.id === apiId);
            updatedApis[index]!.isFavorite = isFavorite;
            return updatedApis;
          }
          return;
        }, false)
      }
      title="Regulatory APIs"
    >
      <TrackRoute name="Regulatory APIs" path="/explorer/apis/regulatory" type="regulatory" />
      <PageTimelineContent />
    </ApiPage>
  );
}
